import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useUser } from '../../context/UserContext';

const PartnerDashboard = () => {
  const { user, isAuthenticated } = useUser();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated || user?.role !== 'partner') {
      navigate('/partner/login');
      return;
    }
    fetchDashboard();
  }, [isAuthenticated, user]);

  const fetchDashboard = async () => {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const response = await axios.get('http://localhost:5000/api/partner/dashboard', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(response.data.data);
    } catch (error) {
      console.error('Error fetching dashboard:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="text-center py-80">Loading...</div>;

  return (
    <section className="partner-dashboard py-80">
      <div className="container container-lg">
        <div className="d-flex justify-content-between align-items-center mb-40">
          <h1>Partner Dashboard</h1>
          <div className="badge bg-info-600 text-white px-16 py-8 rounded-pill">
            Read-Only Access
          </div>
        </div>
        
        <div className="row g-4">
          <div className="col-md-3">
            <div className="bg-white p-24 rounded-16 shadow-sm">
              <h3 className="text-3xl fw-bold text-main-600">{stats?.totalUsers || 0}</h3>
              <p className="text-gray-600 mb-0">Total Users</p>
            </div>
          </div>
          
          <div className="col-md-3">
            <div className="bg-white p-24 rounded-16 shadow-sm">
              <h3 className="text-3xl fw-bold text-main-600">{stats?.totalSellers || 0}</h3>
              <p className="text-gray-600 mb-0">Total Sellers</p>
            </div>
          </div>
          
          <div className="col-md-3">
            <div className="bg-white p-24 rounded-16 shadow-sm">
              <h3 className="text-3xl fw-bold text-warning-600">{stats?.pendingSellers || 0}</h3>
              <p className="text-gray-600 mb-0">Pending Approvals</p>
            </div>
          </div>
          
          <div className="col-md-3">
            <div className="bg-white p-24 rounded-16 shadow-sm">
              <h3 className="text-3xl fw-bold text-success-600">{stats?.totalOrders || 0}</h3>
              <p className="text-gray-600 mb-0">Total Orders</p>
            </div>
          </div>
        </div>

        <div className="mt-40">
          <div className="alert alert-info">
            <i className="ph ph-info me-2"></i>
            You have read-only access to view platform analytics.
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnerDashboard;